import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.onActivity = this.handleActivity.bind(this);
    document.addEventListener("poll:activity", this.onActivity);
  }

  disconnect() {
    document.removeEventListener("poll:activity", this.onActivity);
  }

  handleActivity() {
    document.getElementById("polls-none-open")?.remove();
    this.showUnread(this.tab);
  }

  removeUnread() {
    this.tab.classList.remove("unread");
  }

  get tab() {
    const tabName = this.element.dataset.tab;
    return document.querySelector(`.tabs-dashboard [data-tab="${tabName}"]`);
  }

  showUnread(tab) {
    if (!tab.classList.contains("active")) {
      tab.classList.add("unread");
    }
  }
}
